import PropTypes from "prop-types";
import React from 'react';
import { BASE_API_GAMBAR } from "../../config";
import Avatar from 'react-avatar';

const Testimonial = ({ data }) => {
    return (
        <div className="static-testimonial mb-6">
            <div className="testimonial-image">
                {data.image != "" || data.image != null ? 
                <img src={BASE_API_GAMBAR + "/" + data.image} alt="" width={"20%"} />
                : <Avatar name={data.name} /> }
            </div>
            <div className="testimonial-content">
                <p>{data.desc}</p>
            </div>
            <div className="author-info">
                <div className="cite">
                    <h6 className="name">{data.name}</h6>
                    <span className="position">{data.position}</span>
                </div>
            </div>
        </div>
    )
}

Testimonial.propTypes = {
    data: PropTypes.object
};

export default Testimonial;
